/**
 * Servicio API para SB Horizontal Video Campaigns
 * Video 16:9 para desktop/tablet
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const SbHorizontalVideoCampaignAPI = {

    /**
     * Sube archivos: video, CSV de targeting
     */
    uploadFiles: async function (video, targetingCSV, negativeCSV) {
        const formData = new FormData();

        if (video) formData.append('video', video);
        if (targetingCSV) formData.append('targetingCSV', targetingCSV);
        if (negativeCSV) formData.append('negativeCSV', negativeCSV);

        const response = await fetch(`${API_BASE_URL}/sb-horizontal-video/upload`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error uploading files');
        }

        return await response.json();
    },

    /**
     * Creates a horizontal video campaign
     */
    createCampaign: async function (options) {
        const formData = new FormData();

        formData.append('profileId', options.profileId);
        formData.append('campaignName', options.campaignName);
        formData.append('dailyBudget', options.dailyBudget);
        formData.append('startDate', options.startDate);
        formData.append('endDate', options.endDate || '');
        formData.append('defaultBid', options.defaultBid);
        formData.append('state', options.state);
        formData.append('brandEntityId', options.brandEntityId);
        formData.append('targetingType', options.targetingType);
        formData.append('adFormat', 'video');

        // Multiple ASINs (up to 3)
        formData.append('productAsins', JSON.stringify(options.productAsins));
        formData.append('targeting', JSON.stringify(options.targeting));

        if (options.video) formData.append('video', options.video);
        if (options.negatives) formData.append('negatives', JSON.stringify(options.negatives));

        const response = await fetch(`${API_BASE_URL}/sb-horizontal-video/create`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error creating campaign');
        }

        return await response.json();
    },

    /**
     * Obtiene marcas disponibles
     */
    getBrands: async function (profileId) {
        const response = await fetch(`${API_BASE_URL}/sb-horizontal-video/brands?profileId=${profileId}`);
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error loading brands');
        }
        return await response.json();
    }
};

export default SbHorizontalVideoCampaignAPI;


